import { Api } from "~/api";
import { addBreadcrumb } from "~/redux/action-creaters/breadcrumbs";
import { getSettings } from "~/redux/action-creaters/content";
import { setFilterParams } from "~/redux/action-creaters/filter";
import { setDescription, setTitle } from "~/redux/action-creaters/meta";
import { fetchTopMarks } from "~/redux/action-creaters/models";
import { fetchProduct } from "~/redux/action-creaters/product";
import { fetchProps } from "~/redux/action-creaters/props";
import {
  fetchSection,
  setPageNum,
  setSectionId,
} from "~/redux/action-creaters/section";
import { fetchSections } from "~/redux/action-creaters/sections";
import {
  checkIsBaltex,
  checkIsLanding,
  formatType,
  setTextCity,
} from "~/utils/index";

export enum PageTypes {
  notFound,
  filter,
  product,
  section,
  sections,
}

export async function detectPageType(store: any, path: any, isReset: boolean) {
  const PageData: any = {
    pageType: PageTypes.section,
    section: {},
    filterParams: {},
    productCode: "",
  };
  await store.dispatch(fetchSections(isReset));
  const { sections } = store.getState();

  path.forEach((code: string) => {
    if (PageData.pageType === PageTypes.notFound) {
      return;
    }
    if (PageData.pageType === PageTypes.filter) {
      const [param, ...value] = code.split("-");
      PageData.filterParams[param] = value.filter((v) => v !== "or" && v);
      return;
    }
    if (PageData.pageType === PageTypes.product) {
      PageData.pageType = PageTypes.notFound;
      return;
    }
    if (code === "filter") {
      PageData.pageType = PageTypes.filter;
      return;
    }
    let found = false;
    for (const sectionId in sections.sections) {
      const iSection = sections.sections[sectionId];
      if (iSection.CODE !== code) {
        continue;
      }
      if (
        PageData.section.ID &&
        PageData.section.ID != iSection.IBLOCK_SECTION_ID
      ) {
        continue;
      }
      store.dispatch(
        addBreadcrumb({ link: iSection.SECTION_PAGE_URL, name: iSection.NAME }),
      );
      PageData.section = { ...iSection };
      found = true;
      break;
    }

    if (!found) {
      if (PageData.section.ID) {
        PageData.pageType = PageTypes.product;
        PageData.productCode = code;
      } else {
        PageData.pageType = PageTypes.notFound;
      }
    }
  });

  if (
    PageData.pageType === PageTypes.section &&
    PageData.section.HAS_CHILDS === "Y"
  ) {
    PageData.pageType = PageTypes.sections;
  }

  return PageData;
}

export function filterLogic(
  PageData: any,
  store: any,
  host: string,
  resolvedUrl: string,
) {
  if (!Object.keys(PageData.filterParams).length) {
    return {
      redirect: {
        destination: PageData.section.SECTION_PAGE_URL,
        permanent: true,
      },
    };
  }

  let newUrl = "";
  let isDoubleParamsDetected = false;
  Object.keys(PageData.filterParams).map((key) => {
    if (
      PageData.filterParams[key].length >
      new Set(PageData.filterParams[key]).size
    ) {
      isDoubleParamsDetected = true;
    }
  });
  if (isDoubleParamsDetected) {
    newUrl = `${resolvedUrl.split("/filter/")[0]}/filter/`;
    Object.keys(PageData.filterParams).map((key) => {
      newUrl += `${key}-${Array.from(new Set(PageData.filterParams[key])).join("-or-")}/`;
    });
    return {
      redirect: {
        destination: newUrl,
        permanent: true,
      },
    };
  }

  if (!PageData.section.ID) {
    return {
      redirect: {
        destination: "/catalog/",
        permanent: true,
      },
    };
  }

  let newUrlFilter = "";
  Object.keys(PageData.filterParams).map((key) => {
    if (PageData.filterParams[key].length === 0) {
      newUrlFilter = resolvedUrl.split(key)[0];
    }
  });

  if (newUrlFilter) {
    return {
      redirect: {
        destination: newUrlFilter,
        permanent: true,
      },
    };
  }
  if (checkIsBaltex(host)) {
    PageData.filterParams.proizvoditel = ["baltex", "towrus"];
    if (
      ![
        "/catalog/farkopy/",
        "/catalog/vstavki_pod_kvadrat/",
        "/catalog/elektrika_farkopov/",
      ].includes(PageData.section.SECTION_PAGE_URL)
    ) {
      return {
        notFound: true,
      };
    }
  }
  if (checkIsLanding(host)) {
    let mark = host.split(".")?.[0].split("-")[1];
    if (mark === "landrover") {
      mark = "land_rover";
    }
    PageData.filterParams.marka = [mark];
  }
  store.dispatch(setFilterParams(PageData.filterParams));
  return null;
}

export function filterIndexLogic(PageData: any, isBaltex: boolean) {
  let isIndex = true;
  if (
    Object.keys(PageData.filterParams).filter(
      (item) => !["marka", "model", "kuzov"].includes(item),
    ).length > 1
  ) {
    isIndex = false;
  }
  Object.keys(PageData.filterParams).forEach((key) => {
    if (
      (isBaltex && PageData.filterParams[key].length > 3) ||
      (!isBaltex && PageData.filterParams[key].length > 1)
    ) {
      isIndex = false;
    }
  });
  return isIndex;
}

export async function productLogic(
  ProductData: any,
  Redis: any,
  store: any,
  host: string,
  isReset: boolean,
) {
  await store.dispatch(fetchProduct(ProductData.productCode, host, isReset));
  await store.dispatch(fetchProps(Redis, isReset));
  const { product } = store.getState();

  if (
    checkIsBaltex(host) &&
    ![635, 636, 716].includes(product.product.IBLOCK_SECTION_ID)
  ) {
    return {
      notFound: true,
    };
  }

  if (
    checkIsBaltex(host) &&
    product.product.PROIZVODITEL !== 126035 &&
    product.product.PROIZVODITEL !== 135370
  ) {
    return {
      notFound: true,
    };
  }

  if (!product.product?.ID) {
    return {
      notFound: true,
    };
  }

  if (isReset && product.product.PHOTOS_NEW?.length > 0) {
    Redis.sadd("photoService_changedProductIds", product.product.ID);
  }

  if (!product.product.ACTIVE) {
    return {
      notFound: true,
    };
  }
  if (product.product.IBLOCK_SECTION_ID != ProductData.section.ID) {
    return {
      notFound: true,
    };
  }
  store.dispatch(
    setTitle(
      formatType(
        product.product.META?.ELEMENT_META_TITLE ?? product.product.NAME,
      ),
    ),
  );
  store.dispatch(
    setDescription(
      formatType(
        product.product.META?.ELEMENT_META_DESCRIPTION ?? product.product.NAME,
      ),
    ),
  );
  buildProductBreadCrumbsLogic(store, product, ProductData.section);
}

export function buildProductBreadCrumbsLogic(
  store: any,
  product: any,
  section: any,
) {
  let link = `/${section.SECTION_PAGE_URL}`;
  if (product.product.MARKA?.VALUE) {
    link += `filter/marka-${product.product.MARKA.CODE_ALT}/`;
    store.dispatch(
      addBreadcrumb({
        link,
        name: product.product.MARKA.VALUE,
      }),
    );
    if (product.product.MODEL?.VALUE) {
      link += `model-${product.product.MODEL.CODE_ALT}/`;
      store.dispatch(
        addBreadcrumb({
          link,
          name: product.product.MODEL.VALUE,
        }),
      );
      if (product.product.KUZOV?.VALUE) {
        link += `kuzov-${product.product.KUZOV.CODE_ALT}/`;
        store.dispatch(
          addBreadcrumb({
            link,
            name: formatType(product.product.KUZOV.VALUE),
          }),
        );
      }
    }
  }
  store.dispatch(
    addBreadcrumb({
      link: product.product.DETAIL_PAGE_URL,
      name: formatType(product.product.NAME),
    }),
  );
}

export async function sectionsLogic(
  PageData: any,
  store: any,
  host: string,
  isReset: boolean,
) {
  const domains = await Api.server.getDomains(isReset);
  const sectionMeta = await Api.sections.getSectionMeta(PageData.section.ID);
  Object.keys(sectionMeta).forEach((key) => {
    sectionMeta[key] = setTextCity(host, domains, sectionMeta[key]);
  });
  store.dispatch(
    setTitle(sectionMeta?.SECTION_META_TITLE ?? PageData.section.NAME),
  );
  store.dispatch(
    setDescription(
      sectionMeta?.SECTION_META_DESCRIPTION ?? PageData.section.NAME,
    ),
  );
}

export async function sectionLogic(
  PageData: any,
  Redis: any,
  store: any,
  host: any,
  resolvedUrl: string,
  query: any,
  isReset: boolean,
) {
  await store.dispatch(fetchProps(Redis, isReset));
  store.dispatch(setSectionId(PageData.section.ID));
  if (query.PAGEN_1) {
    store.dispatch(setPageNum(parseInt(query.PAGEN_1)));
  }
  await store.dispatch(getSettings(Redis, isReset));
  await store.dispatch(fetchSection(Redis, host, resolvedUrl, isReset));
  await store.dispatch(fetchTopMarks(Redis, isReset));
  const { filter } = store.getState();
  if (!filter?.isValidFilter) {
    return {
      redirect: {
        destination: PageData.section.SECTION_PAGE_URL,
        permanent: true,
      },
    };
  }
  const { section: sectionData } = store.getState();
  store.dispatch(setTitle(sectionData?.meta?.title ?? PageData.section.NAME));
  store.dispatch(
    setDescription(sectionData?.meta?.description ?? PageData.section.NAME),
  );
  if (Boolean(query.reset) && sectionData.products?.length > 0) {
    Redis.sadd(
      "photoService_changedProductIds",
      ...sectionData.products.map((product: any) => product.ID),
    );
  }

  return buildSectionBreadCrumbsLogic(PageData, store, checkIsLanding(host));
}

export function buildSectionBreadCrumbsLogic(
  PageData: any,
  store: any,
  isLanding: boolean,
) {
  const { models } = store.getState();
  let link = `${PageData.section.SECTION_PAGE_URL}`;
  if (PageData.filterParams.marka?.[0]) {
    const marka = models.marks[PageData.filterParams.marka?.[0]];
    if (marka) {
      link += `filter/marka-${PageData.filterParams.marka?.[0]}/`;
      store.dispatch(
        addBreadcrumb({
          link,
          name: marka.NAME,
        }),
      );

      if (PageData.filterParams.model?.[0]) {
        const model = models.models[PageData.filterParams.model?.[0]];
        if (model) {
          link += `model-${PageData.filterParams.model?.[0]}/`;

          store.dispatch(
            addBreadcrumb({
              link,
              name: model.NAME,
            }),
          );

          if (PageData.filterParams.kuzov?.[0]) {
            const type = models.types[PageData.filterParams.kuzov[0]];
            if (type) {
              link += `kuzov-${PageData.filterParams.kuzov[0]}/`;
              store.dispatch(
                addBreadcrumb({
                  link,
                  name: formatType(type.NAME),
                }),
              );
            } else {
              return {
                redirect: {
                  destination: link,
                  permanent: true,
                },
              };
            }
          } else if (Object.keys(models.types).length === 1) {
            link += `kuzov-${Object.keys(models.types)[0]}/`;
            return {
              redirect: {
                destination: link,
                permanent: true,
              },
            };
          }
        } else {
          return {
            redirect: {
              destination: link,
              permanent: true,
            },
          };
        }
      } else if (PageData.filterParams.kuzov?.[0]) {
        return {
          redirect: {
            destination: link,
            permanent: true,
          },
        };
      } else if (Object.keys(models.models).length === 1) {
        link += `model-${Object.keys(models.models)[0]}/`;

        /* const types = await Api.catalog.getTypesByMarkAndModel(Redis, {
                    marka: filterParams.marka?.[0],
                    model: Object.keys(models.models)[0],
                    sectionId: section['ID']
                })

                if (types.types && types.types.length === 1) {
                    link += `kuzov-${types.types[0].CODE}/`
                } */

        return {
          redirect: {
            destination: link,
            permanent: true,
          },
        };
      }
    } else {
      return {
        redirect: {
          destination: isLanding ? "/catalog/" : link,
          permanent: true,
        },
      };
    }
  } else if (
    PageData.filterParams.model?.[0] ||
    PageData.filterParams.kuzov?.[0]
  ) {
    return {
      redirect: {
        destination: PageData.section.SECTION_PAGE_URL,
        permanent: true,
      },
    };
  }
}
